// @flow
import axiosRetry from 'axios-retry'
import { createAxiosInstance } from './axios'
import { RequestInterceptor } from './interceptors/request'
import { ResponseInterceptorSuccess } from './interceptors/response'
import { ResponseInterceptorFail } from './interceptors/responseFail'

const ApiService = createAxiosInstance()

ApiService.interceptors.request.use(RequestInterceptor)
ApiService.interceptors.response.use(ResponseInterceptorSuccess, ResponseInterceptorFail)

axiosRetry(ApiService, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
})

export { ApiService as Api }
